"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fin = exports.FinClasses = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var css_1 = require("@emotion/css");
var _const_1 = require("../../style");
var _hooks_1 = require("../../hooks");
exports.FinClasses = {
    root: 'fin-container',
    icon: 'fin-icon',
};
var FinContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n\n  border-radius: 24px;\n  overflow: hidden;\n\n  position: relative;\n\n  cursor: pointer;\n"], ["\n  width: 48px;\n  height: 48px;\n\n  border-radius: 24px;\n  overflow: hidden;\n\n  position: relative;\n\n  cursor: pointer;\n"])));
var FinWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  transition: background-color 0.2s ", ";\n  &:not(.fin-active): hover {\n    background-color: rgba(30, 30, 30, 0.3);\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  transition: background-color 0.2s ", ";\n  &:not(.fin-active): hover {\n    background-color: rgba(30, 30, 30, 0.3);\n  }\n"])), _const_1.EASE_IN_OUT);
var FinIcon = styled_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 26px;\n  height: 26px;\n\n  color: #1e1e1e;\n\n  transition: color 0.2s ", ";\n\n  .fin-active & {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 26px;\n  height: 26px;\n\n  color: #1e1e1e;\n\n  transition: color 0.2s ", ";\n\n  .fin-active & {\n    color: ", ";\n  }\n"])), _const_1.EASE_IN_OUT, function (props) { return props.color; });
/**
 * Floating Icon Navigation's Icon Component
 *
 * @component
 * @example
 * return (
 *   <Fin icon={`IconCopmonent`} active={`color string` or `boolean`} />
 * )
 */
function Fin(props) {
    // prop destruction
    var icon = props.icon, index = props.index, path = props.path, activeColor = props.activeColor, children = props.children;
    // lib hooks
    var currentPath = (0, _hooks_1.useFin)().currentPath;
    var _a = (0, _hooks_1.useFinStart)(), triggerStart = _a[0], registerStart = _a[1];
    var _b = (0, _hooks_1.useFinEnd)(), _ = _b[0], registerEnd = _b[1];
    var _c = (0, _hooks_1.useFinSetting)(), __ = _c[0], ___ = _c[1], registerSettingEnd = _c[2];
    var triggerRegister = (0, _hooks_1.useFinRegister)()[0];
    // state, ref, querystring hooks
    var _d = (0, react_1.useState)(false), active = _d[0], setActive = _d[1];
    var _e = (0, react_1.useState)(false), isAnimating = _e[0], setIsAnimating = _e[1];
    var me = (0, react_1.useRef)(null);
    // form hooks
    // query hooks
    // calculated values
    var color = (0, react_1.useMemo)(function () { return activeColor !== null && activeColor !== void 0 ? activeColor : _const_1.DEFAULT_COLOR; }, [activeColor]);
    var myPositionX = (0, react_1.useMemo)(function () {
        if (me.current) {
            return me.current.offsetLeft - _const_1.OFFSET_ERROR;
        }
        return undefined;
    }, [me.current]);
    // effects
    (0, react_1.useEffect)(function () {
        registerSettingEnd(function (event) {
            if (event.currentPath === path) {
                setActive(true);
            }
            triggerRegister({
                currentPath: path,
                children: children,
            });
        });
        registerStart(function (event) {
            setIsAnimating(true);
            if (event.nextPath === path)
                setActive(true);
            else
                setActive(false);
        });
        registerEnd(function () {
            setIsAnimating(false);
        });
    }, []);
    // handlers
    var handleNavigate = function () {
        if (active || isAnimating)
            return;
        triggerStart({
            currentPath: currentPath,
            nextPath: path,
            indicatorX: myPositionX,
        });
    };
    return ((0, jsx_runtime_1.jsx)(FinContainer, { ref: me, className: (0, css_1.cx)("fin-".concat(path, "--container"), index && 'fin-index--container', exports.FinClasses.root), "data-path": path, children: (0, jsx_runtime_1.jsx)(FinWrapper, { onClick: handleNavigate, className: (0, css_1.cx)("fin-".concat(path, "--wrapper"), index && 'fin-index', active && 'fin-active'), children: (0, jsx_runtime_1.jsx)(FinIcon, { className: exports.FinClasses.icon, color: color, children: icon }) }) }));
}
exports.Fin = Fin;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Fin.js.map